export const getCalculatedProperty = <Property, MobileProperty>({
  desktopProperty,
  mobileProperty,
  globalDesktopProperty,
  globalMobileProperty,
}: {
  desktopProperty: Property
  mobileProperty: MobileProperty | undefined
  globalDesktopProperty: Property
  globalMobileProperty?: MobileProperty | undefined
}) => {
  return {
    mobile:
      mobileProperty ||
      globalMobileProperty ||
      desktopProperty ||
      globalDesktopProperty,
    desktop: desktopProperty || globalDesktopProperty,
  }
}
